import { __decorate, __metadata } from 'tslib';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { EventEmitter, Input, Output, ViewChild, Component, NgModule } from '@angular/core';
import { CountdownComponent, CountdownModule, CountdownGlobalConfig } from 'ngx-countdown';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TooltipModule } from 'ngx-tooltip';
import { UiCButtonModule } from '@wlp/ui-c-button';

let UiCSendCodeAccountActivationComponent = class UiCSendCodeAccountActivationComponent {
    constructor() {
        this.onChange = new EventEmitter();
        this.formSendCodeEmitter = new EventEmitter();
    }
    textActionBtn() {
        this.countdown.restart();
        /* this.textActionEvent.emit(); */
    }
    focusValue(data) {
        // console.log('focusValue', data);
    }
    onKeyDown(evt) {
        const numKeyCode = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 8, 46];
        const iKeyCode = (evt.which) ? evt.which : evt.keyCode;
        // return numKeyCode.includes(iKeyCode);
        return numKeyCode.indexOf(iKeyCode) !== -1;
    }
    nextElement(previusElement, currentElement, nextElement, event) {
        if (event.keyCode === 8) {
            if (!currentElement.value) {
                previusElement.focus();
                return;
            }
            return;
        }
        // console.log('onKeyUp', event);
        if (currentElement.value) {
            nextElement.focus();
        }
        if (currentElement === nextElement) {
            nextElement.blur();
        }
        this.sendCodeEmitter();
    }
    sendCodeEmitter() {
        if (this.formSendCode.valid) {
            this.formSendCodeEmitter.emit(this.formSendCode);
            return;
        }
    }
};
__decorate([
    Input(),
    __metadata("design:type", Number)
], UiCSendCodeAccountActivationComponent.prototype, "counter", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCSendCodeAccountActivationComponent.prototype, "errorMessages", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCSendCodeAccountActivationComponent.prototype, "textMessage", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCSendCodeAccountActivationComponent.prototype, "textAction", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCSendCodeAccountActivationComponent.prototype, "isDisabled", void 0);
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], UiCSendCodeAccountActivationComponent.prototype, "formSendCode", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], UiCSendCodeAccountActivationComponent.prototype, "progressbarValue", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCSendCodeAccountActivationComponent.prototype, "onChange", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCSendCodeAccountActivationComponent.prototype, "formSendCodeEmitter", void 0);
__decorate([
    ViewChild('cd', { static: false }),
    __metadata("design:type", CountdownComponent)
], UiCSendCodeAccountActivationComponent.prototype, "countdown", void 0);
UiCSendCodeAccountActivationComponent = __decorate([
    Component({
        selector: 'ui-c-send-code-account-activation',
        template: "<div class=\"send-code-component\">\n  <form class=\"w100 ion-text-center\" [formGroup]=\"formSendCode\">    \n    <div class=\"box-radius border\">\n      <input type=\"tel\" #codeOne maxlength=\"1\" formControlName=\"codeNumberOne\" (focus)=\"focusValue($event)\"\n        (keydown)=\"onKeyDown($event)\" (keyup)=\"nextElement(codeOne, codeOne, codeTwo, $event)\"\n        class=\"input-code code-number-one ion-text-center\" onfocus>\n      <input type=\"tel\" #codeTwo maxlength=\"1\" formControlName=\"codeNumberTwo\" (keydown)=\"onKeyDown($event)\"\n        (keyup)=\"nextElement(codeOne, codeTwo, codeThree, $event)\" class=\"input-code code-number-two ion-text-center\">\n      <input type=\"tel\" #codeThree maxlength=\"1\" formControlName=\"codeNumberThree\" (keydown)=\"onKeyDown($event)\"\n        (keyup)=\"nextElement(codeTwo, codeThree,  codeFour, $event)\"\n        class=\"input-code code-number-three ion-text-center\">\n      <input type=\"tel\" #codeFour maxlength=\"1\" formControlName=\"codeNumberFour\" (keydown)=\"onKeyDown($event)\"\n        (keyup)=\"nextElement(codeThree, codeFour, codeFive, $event)\"\n        class=\"input-code code-number-four ion-text-center\">\n      <input type=\"tel\" #codeFive maxlength=\"1\" formControlName=\"codeNumberFive\" (keydown)=\"onKeyDown($event)\"\n        (keyup)=\"nextElement(codeFour, codeFive, codeFive, $event)\" class=\"input-code code-number-five ion-text-center\">\n    </div>\n  </form>\n</div>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCSendCodeAccountActivationComponent);

let UiCSendCodeAccountActivationModule = class UiCSendCodeAccountActivationModule {
};
UiCSendCodeAccountActivationModule = __decorate([
    NgModule({
        declarations: [UiCSendCodeAccountActivationComponent],
        imports: [
            IonicModule,
            CommonModule,
            CountdownModule,
            ReactiveFormsModule,
            TooltipModule,
            UiCButtonModule,
        ],
        exports: [UiCSendCodeAccountActivationComponent, CountdownModule],
        providers: [
            { provide: CountdownGlobalConfig }
        ],
    })
], UiCSendCodeAccountActivationModule);

export { UiCSendCodeAccountActivationComponent, UiCSendCodeAccountActivationModule };
//# sourceMappingURL=wlp-ui-c-send-code-account-activation.js.map
